/* PostHog storefront analytics. Shopify consent is the authority; no customer identity. */
(function () {
  'use strict';
  var node = document.getElementById('alasil-posthog-config');
  if (window.AlAsilAnalyticsEnvironment?.enabled === false || !node || window.__alasilPosthog || !/^(www\.)?alasil\.ae$/.test(location.hostname) ||
      /\/(account|checkout|checkouts|orders)(\/|$)/.test(location.pathname) ||
      new URLSearchParams(location.search).has('preview_theme_id') || window.Shopify?.designMode) return;
  window.__alasilPosthog = true;
  var config = JSON.parse(node.textContent);
  var initialDocumentPath = location.pathname;
  var linkedTransitionObserved = false;
  // Search echoes free text into headings and attributes outside masked inputs.
  var searchPage = /\/search(?:\/|$)/.test(location.pathname);
  var sdk = null;
  var loading = false;
  var pageSent = false;
  var bridgeKey = 'alasil_posthog_bridge_v1';
  var sessionActivity = null;
  var contextIdentity = null;
  var recordingTimer = null;
  var recordingIdle = null;
  var recordingStarted = false;
  var pendingFunnel = [];
  var funnelLifetime = 30000;

  function cancelRecordingStart() {
    if (recordingTimer !== null) window.clearTimeout(recordingTimer);
    if (recordingIdle !== null && window.cancelIdleCallback) window.cancelIdleCallback(recordingIdle);
    recordingTimer = null;
    recordingIdle = null;
  }
  function scheduleRecording() {
    if (!sdk || searchPage || recordingStarted || !allowed() ||
        document.readyState !== 'complete' || document.prerendering === true || document.visibilityState === 'hidden' ||
        recordingTimer !== null || recordingIdle !== null) return;
    // Replay snapshots walk the DOM. Let critical rendering and load handlers
    // finish first; do not make the visitor's first tap initialize the recorder.
    recordingTimer = window.setTimeout(function () {
      recordingTimer = null;
      function startRecording() {
        recordingIdle = null;
        // Consent or visibility can change while waiting for background time.
        if (!sdk || recordingStarted || !allowed() || searchPage || document.prerendering === true || document.visibilityState === 'hidden') return;
        sdk.startSessionRecording();
        recordingStarted = true;
      }
      if (window.requestIdleCallback) {
        recordingIdle = window.requestIdleCallback(startRecording, {timeout: 2000});
      } else {
        startRecording();
      }
    }, 1000);
  }

  function syncBridge(observedSessionId, observedAt) {
    try {
      if (!sdk || !allowed()) { sessionActivity = null; contextIdentity = null; window.localStorage.removeItem(bridgeKey); return; }
      var distinctId = sdk.get_distinct_id?.();
      if (typeof distinctId !== 'string' || !/^[a-zA-Z0-9-]{16,80}$/.test(distinctId)) return;
      var sessionId;
      // Reuse the SDK's session, never create a parallel checkout identity.
      // Missing session support must not remove the existing anonymous bridge.
      try { sessionId = observedSessionId || sdk.get_session_id?.(); } catch (_) {}
      var now = Date.now();
      var sessionStart = typeof sessionId === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-7[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(sessionId)
        ? parseInt(sessionId.replace(/-/g, '').slice(0, 12), 16) : NaN;
      if (observedSessionId) {
        // Callback delivery and read-only getters are not new SDK activity.
        if (!Number.isFinite(sessionStart) || !Number.isFinite(observedAt) || observedAt > now || observedAt < sessionStart || observedAt >= sessionStart + 86400000 ||
            (sessionActivity && observedAt < sessionActivity.at)) return;
        sessionActivity = {id: sessionId, at: observedAt};
      }
      var bridge = {
        version: 1, distinct_id: distinctId, updated_at: now,
        ...(sessionStart <= now && now < sessionStart + 86400000 && sessionActivity?.id === sessionId
          ? {session_id: sessionId, session_updated_at: sessionActivity.at} : {})
      };
      window.localStorage.setItem(bridgeKey, JSON.stringify(bridge));
      var nextIdentity = distinctId + ':' + (bridge.session_id || '');
      if (nextIdentity !== contextIdentity) {
        contextIdentity = nextIdentity;
        // No identifier leaves the private bridge through DOM event detail.
        document.dispatchEvent(new Event('alasil:posthog-ready'));
      }
    } catch (_) { /* Storage restrictions must not break shopping. */ }
  }

  function allowed() {
    try {
      return navigator.doNotTrack !== '1' && navigator.globalPrivacyControl !== true &&
        window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  function cleanUrl(value, referrer) {
    try {
      var url = new URL(value, location.origin);
      if (!/^https?:$/.test(url.protocol)) return '';
      var path = url.pathname;
      for (var i = 0; i < 3 && /%[a-f0-9]{2}/i.test(path); i++) path = decodeURIComponent(path);
      if (path.length > 500 || /@|%[a-f0-9]{2}|[\u0000-\u0020\\]|(?:^|\/)(?:account|accounts|checkout|checkouts|orders|reset|password|login|register|payment)(?:\/|$)/i.test(path)) return url.origin;
      var sameSite = url.origin === location.origin;
      if (!sameSite && referrer) return url.origin;
      var asset = /\.(?:css|js|woff2?|ttf|png|jpe?g|webp|avif|gif|svg|ico)$/i.test(path) &&
        ((sameSite && /^\/cdn\/shop\//.test(path)) ||
         (url.hostname === 'cdn.shopify.com' && /^\/s\/files\//.test(path)) ||
         (url.hostname === 'us-assets.i.posthog.com' && /^\/static\//.test(path)));
      var publicPath = sameSite && !/\d{8,}/.test(path) &&
        /^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?(?:(?:products|collections|pages)\/[a-z0-9][a-z0-9_-]*(?:\/products\/[a-z0-9][a-z0-9_-]*)?\/?|search\/?|cart(?:\/(?:add|change|update|clear))?(?:\.js)?\/?)?$/.test(path);
      return url.origin + (asset || publicPath ? path : '');
    }
    catch (_) { return ''; }
  }
  function beforeSend(event) {
    if (!allowed()) return null;
    var p = event.properties || {};
    // Use the captured session directly, without re-entering the SDK here.
    if (p.$session_id && event.event !== '$snapshot') syncBridge(p.$session_id, new Date(event.timestamp).getTime());
    ['$current_url', '$referrer', '$initial_current_url', '$initial_referrer',
      '$session_entry_current_url', '$session_entry_url', '$session_entry_referrer',
      '$session_entry_referrer_url'].forEach(function (key) {
      if (p[key]) p[key] = cleanUrl(p[key], /referrer/.test(key));
    });
    ['$pathname', '$initial_pathname', '$session_entry_pathname'].forEach(function (key) {
      if (typeof p[key] === 'string') {
        try { p[key] = new URL(cleanUrl(p[key]), location.origin).pathname; }
        catch (_) { p[key] = '/'; }
      }
    });
    // Web Vitals repeat URLs inside metric/attribution objects as well.
    if (event.event === '$web_vitals') ['CLS', 'FCP', 'INP', 'LCP'].forEach(function (name) {
      var metric = p['$web_vitals_' + name + '_event'];
      if (!metric || typeof metric !== 'object') return;
      ['$current_url', 'navigationURL'].forEach(function (key) {
        if (typeof metric[key] === 'string') metric[key] = cleanUrl(metric[key]);
      });
      if (typeof metric.attribution?.url === 'string') metric.attribution.url = cleanUrl(metric.attribution.url);
    });
    delete p.$set; delete p.$set_once;
    if (searchPage) delete p.$title;
    return event;
  }
  function capture(name, properties) {
    if (sdk && allowed()) {
      syncBridge();
      sdk.capture(name, Object.assign({page_type: config.pageType}, properties));
    }
  }
  function reconcile() {
    if (!allowed()) {
      pendingFunnel = [];
      cancelRecordingStart();
      recordingStarted = false;
      syncBridge();
      if (sdk) { sdk.stopSessionRecording(); sdk.opt_out_capturing(); }
      return;
    }
    if (!sdk) { load(); return; }
    sdk.opt_in_capturing({captureEventName: false});
    var pending = pendingFunnel;
    pendingFunnel = [];
    pending.forEach(function (event) {
      if (Date.now() - event.at >= 0 && Date.now() - event.at < funnelLifetime) capture(event.name, event.properties);
    });
    syncBridge();
    if (searchPage) sdk.stopSessionRecording();
    else scheduleRecording();
    if (!pageSent) {
      pageSent = true;
      capture('$pageview', {$current_url: cleanUrl(location.href)});
      var initialProduct = visibleProductId();
      // Special product templates can lack MainProduct. Their Liquid identity
      // remains valid only while this is still the unchanged initial document.
      var documentProduct = Number(config.productId);
      if (!initialProduct && !linkedTransitionObserved && location.pathname === initialDocumentPath &&
          /^\d+$/.test(String(config.productId)) && Number.isSafeInteger(documentProduct) && documentProduct > 0) initialProduct = documentProduct;
      if (initialProduct) capture('product_viewed', {product_id: initialProduct, page_type: 'product'});
    }
  }
  function load() {
    if (loading || !allowed()) return;
    loading = true;
    // The public SDK consumes this standard snippet queue on load.
    var queue = window.posthog = window.posthog || [];
    queue._i = queue._i || [];
    queue.__SV = 1;
    queue._i.push([config.token, {
      api_host: 'https://us.i.posthog.com',
      ui_host: 'https://us.posthog.com',
      defaults: '2026-05-30',
      person_profiles: 'never',
      autocapture: true,
      capture_pageview: false,
      capture_pageleave: true,
      capture_performance: true,
      capture_exceptions: false,
      // SDK analytics stay immediate; only the optional DOM recorder waits.
      disable_session_recording: true,
      disable_surveys: true,
      disable_conversations: true,
      disable_product_tours: true,
      advanced_disable_feature_flags: true,
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      persistence: 'localStorage',
      cross_subdomain_cookie: false,
      respect_dnt: true,
      ip: false,
      request_batching: false,
      save_campaign_params: false,
      save_referrer: false,
      mask_all_text: true,
      mask_all_element_attributes: true,
      enable_recording_console_log: false,
      before_send: beforeSend,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '#AccountDrawer, #SiteLocationPrompt, #CartDrawer, #wa-panel, [data-ph-private]',
        blockSelector: 'iframe, input, textarea, select, [contenteditable], #AccountDrawer, #SiteLocationPrompt, #CartDrawer, #wa-panel, .ai-shop__conversation, #clpLocationPage, .header-location-chip, a[href*="portal.alasil.ae"], [data-ph-private]',
        recordHeaders: false,
        recordBody: false,
        collectFonts: false,
        inlineStylesheet: false,
        maskCapturedNetworkRequestFn: function (request) {
          // Replay passes page/network URLs as `name`; older SDKs used `url`.
          var sanitized = Object.assign({}, request, {requestBody: undefined, responseBody: undefined});
          if (typeof request.name === 'string') sanitized.name = cleanUrl(request.name);
          if (typeof request.url === 'string') sanitized.url = cleanUrl(request.url);
          return sanitized;
        }
      },
      loaded: function (instance) { sdk = instance; reconcile(); }
    }, 'posthog']);
    var script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://us-assets.i.posthog.com/static/array.js';
    script.onerror = function () { loading = false; queue._i = []; script.remove(); };
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', reconcile);
  document.addEventListener('alasil:customer-session-account-changed', function () { pendingFunnel = []; });
  window.addEventListener('pagehide', function () { pendingFunnel = []; });
  // Observe the committed linked-product DOM, as GA4 does. Variant/history
  // changes alone are not product views, and rejected impressions never replay.
  var productMain = function () { return document.querySelector?.('[data-analytics-product-id][id^="MainProduct-"]'); };
  function visibleProductId() {
    var id = productMain()?.dataset.analyticsProductId;
    var numeric = Number(id);
    return /^\d+$/.test(id || '') && Number.isSafeInteger(numeric) && numeric > 0 &&
      /^\/(?:ar\/)?products\/[^/?#]+\/?$/.test(location.pathname) ? numeric : null;
  }
  var viewedProduct = productMain()?.dataset.analyticsProductId;
  var viewedPath = location.pathname;
  document.addEventListener('linkedOptionsLoaded', function (event) {
    var previousProduct = viewedProduct, previousPath = viewedPath;
    viewedProduct = productMain()?.dataset.analyticsProductId;
    viewedPath = location.pathname;
    if (previousProduct !== viewedProduct || previousPath !== viewedPath) linkedTransitionObserved = true;
    try {
      if (!previousProduct || previousProduct === viewedProduct || previousPath === viewedPath || !sdk || !allowed()) return;
      var productId = visibleProductId();
      if (!productId) return;
      var committed = new URL(event.detail?.url, location.href);
      if (committed.origin !== location.origin || committed.pathname !== viewedPath) return;
      capture('product_viewed', {product_id: productId, page_type: 'product'});
    } catch (_) { /* Optional analytics cannot affect the committed product. */ }
  });
  document.addEventListener('alasil:funnel', function (event) {
    if (!allowed()) return;
    var data = event.detail || {}, properties = {}, name = data.event_name;
    if (name === 'view_cart') properties.cart_type = 'drawer';
    else if (name === 'continue_as_guest') properties.step_name = 'account';
    else if (name === 'checkout_step_viewed' && ['account', 'delivery', 'contact'].includes(data.step_name)) {
      properties.step_name = data.step_name;
      properties.step_index = {account: 2, delivery: 3, contact: 4}[data.step_name];
    } else return;
    // Preserve the permitted observation's public route while the SDK loads.
    // Do not invent an earlier SDK timestamp or a session/user identity.
    properties.$current_url = cleanUrl(location.href);
    if (sdk) capture(name, properties);
    else if (loading) {
      var now = Date.now();
      pendingFunnel = pendingFunnel.filter(function (event) { return now - event.at >= 0 && now - event.at < funnelLifetime; });
      if (pendingFunnel.length < 30) pendingFunnel.push({name: name, properties: properties, at: now});
    }
  });
  document.addEventListener('prerenderingchange', scheduleRecording);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') cancelRecordingStart();
    else scheduleRecording();
  });
  document.addEventListener('cart:mutation-complete', function (event) {
    var operation = event.detail?.operation;
    if (event.detail?.success === true && ['add', 'change', 'remove', 'update', 'clear'].includes(operation)) capture('cart_updated', {operation: operation});
  });
  document.addEventListener('click', function (event) {
    var target = event.target.closest?.('a, button');
    if (!target) return;
    if (target.id === 'wa-btn') capture('support_opened', {channel: 'whatsapp'});
    if (target.matches('[name="checkout"], a[href="/checkout"]')) capture('checkout_clicked', {});
  }, {passive: true});
  function init() {
    if (window.Shopify?.customerPrivacy) reconcile();
    else if (window.Shopify?.loadFeatures) {
      Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) reconcile(); });
    }
  }
  init();
  window.addEventListener('load', init, {once: true});
})();
